import { Button } from './catalyst/button';
import { Text } from './catalyst/text';

interface EmptyListPlaceholderProps {
  message: string;
  buttonText: string;
  onButtonClick: () => void;
}

export const EmptyListPlaceholder = ({
  message,
  buttonText,
  onButtonClick,
}: EmptyListPlaceholderProps) => {
  return (
    <div className="text-center py-8 bg-gray-50 rounded-lg">
      <Text className="text-gray-500 mb-4">{message}</Text>
      <Button onClick={onButtonClick}>{buttonText}</Button>
    </div>
  );
};
